export const incomeMethodKey = value => String(value || "")
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .toLocaleLowerCase("it-IT").trim().replace(/\s+/g, " ");

export const existingForMethod = (day, method, localeId) => (day.esistenti?.entrate || [])
  .filter(item => item.locale_id === localeId && incomeMethodKey(item.metodo) === incomeMethodKey(method));